import { render } from "./CustomFrequencyModal.vue?vue&type=template&id=13a766dc&ts=true"
import script from "./CustomFrequencyModal.vue?vue&type=script&lang=ts"
export * from "./CustomFrequencyModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__